import { AppRoute } from '@app/core/routing/AppRoute';
import { RouteChildrenProps, Switch } from 'react-router-dom';
import { AdminContentAiPage } from './manage/AdminContentAiPage';

export function AdminContentAiRoutes(props: RouteChildrenProps) {
  const { path } = props.match!;

  return (
    <Switch>
      <AppRoute path={`${path}`} component={AdminContentAiPage} />
    </Switch>
  );
}
